import React, { createClass, PropTypes } from 'react';
import { Paper } from 'material-ui';
import getClassNames from 'classnames';
import $ from 'jquery';

const Card = createClass({

  propTypes: {
    title: PropTypes.string,
    subtitle: PropTypes.string,
    padded: PropTypes.bool,
    isFixed: PropTypes.bool,
    isSticky: PropTypes.bool,
    children: PropTypes.any,
    contentStyle: PropTypes.object,
    className: PropTypes.string,
  },

  getDefaultProps() {
    return {
      padded: true,
    };
  },

  componentDidMount() {
    const resizeCss = function (wrapper) {
      const wRatio = 744 / this.naturalWidth;
      const hRatio = 320 / this.naturalHeight;
      const ratio = Math.min(wRatio, hRatio);

      if (this.naturalWidth > this.naturalHeight) {
        wrapper.css({
          width: this.naturalWidth * ratio,
          height: this.naturalHeight * ratio,
          display: 'block',
          margin: 'auto',
        });
      } else {
        wrapper.css({
          width: this.naturalWidth * ratio,
          height: this.naturalHeight * ratio,
          display: 'block',
          margin: 'auto',
        });
      }
    };

    const $image = $('.tc-card-header-image');
    $image.load(function () {
      resizeCss.call(this, $image);
    });
  },

  render() {
    const classes = getClassNames('tc-card', this.props.className, {
      'is-padded': this.props.padded,
      'is-fixed': this.props.isFixed,
      'is-sticky': this.props.isSticky,
    });

    const headers = [];

    this.props.children.forEach((child, index) => {
      if (index !== this.props.children.length - 1) {
        headers.push(
          <div key={index} className="tc-card-header" style={child.props.headerStyle} >
            {child}
          </div>
        );
      }
    });

    const content = this.props.children[this.props.children.length - 1];

    return (
      <Paper className={classes}>
        {headers}
        <div style={this.props.contentStyle} className="tc-card-contents">
          {content}
        </div>
      </Paper>
    );
  },

});

export default Card;



// WEBPACK FOOTER //
// ./src/app/components/tc-ui/new-card.jsx